import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getKioskPath } from '../lib/kioskMode';

/**
 * NotFound — eigene 404-Seite, die bewusst KEINEN Hinweis auf die
 * Login-Seite enthaelt. Wenn die Browser-Session als Kiosk markiert ist
 * (TV-/Terminal-Geraet), wird sofort auf den Kiosk-Pfad zurueckgeleitet.
 */
export default function NotFound() {
  const navigate = useNavigate();

  useEffect(() => {
    const kiosk = getKioskPath();
    if (kiosk) {
      navigate(kiosk, { replace: true });
    }
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100 p-6">
      <div className="text-center">
        <p className="text-6xl font-bold text-gray-300 mb-2">404</p>
        <h1 className="text-xl font-semibold text-gray-700 mb-2">Seite nicht gefunden</h1>
        <p className="text-sm text-gray-500 max-w-sm mx-auto">
          Diese Adresse existiert nicht. Bitte verwende einen Lesezeichen-Link
          oder kontaktiere deine:n Administrator:in.
        </p>
      </div>
    </div>
  );
}
